import { SecureTenantStore } from '@infra/persistence/SecureTenantStore';
import {
  COMPTES_TVA_PAR_DEFAUT,
  ComptesTvaInvalideError,
  ROLES_COMPTE_TVA,
  resoudreComptesTva,
  type SurchargesComptesTva,
  type TableComptesTva,
} from '@domain/fiscalite/ComptesTva';
import { logger } from '@infra/telemetry/Logger';

const KEY = 'compta.comptes_tva';

/** Table de comptes de TVA de l'entreprise ; valeur invalide : défauts, journalisé. */
export async function loadComptesTva(tenantId: string): Promise<TableComptesTva> {
  const raw = await SecureTenantStore.getJson<unknown>(tenantId, KEY, {});
  if (raw === null || typeof raw !== 'object' || Array.isArray(raw)) return COMPTES_TVA_PAR_DEFAUT;
  try {
    return resoudreComptesTva(raw as SurchargesComptesTva);
  } catch (err) {
    if (!(err instanceof ComptesTvaInvalideError)) throw err;
    logger.warn({ event: 'comptes_tva_invalides', message: err.message });
    return COMPTES_TVA_PAR_DEFAUT;
  }
}

/** Enregistre la table (validée) : seuls les rôles différents des défauts sont stockés. */
export async function saveComptesTva(
  tenantId: string,
  surcharges: SurchargesComptesTva,
): Promise<TableComptesTva> {
  const table = resoudreComptesTva(surcharges);
  const minimal: SurchargesComptesTva = {};
  for (const role of ROLES_COMPTE_TVA) {
    if (JSON.stringify(table[role]) !== JSON.stringify(COMPTES_TVA_PAR_DEFAUT[role])) minimal[role] = table[role];
  }
  await SecureTenantStore.setJson(tenantId, KEY, minimal);
  return table;
}
